import React from 'react';
import Card, { CardTitle } from '../../components/Card';
import Styles from './dashboardStyle.module.scss';
import { useNavigate } from 'react-router-dom';

const DeviceBreakedown = ({ compliancesInfo, groupId }) => {
  const navigate = useNavigate();

  const groupParam = groupId ? `&groupId=${groupId}` : '';

  const handleOnClick = (action) => {
    navigate(`/deviceManagement?action=${action}${groupParam}`);
  };

  return (
    <Card className={Styles['breakedown-card']}>
      <CardTitle title="Devices Overview Breakdown">
        <div className="flex justify-between items-center">
          <div>
            Device Compliance Overview
            <hr />
          </div>
        </div>
      </CardTitle>

      <div className={Styles['breakedown-content']}>
        {/* Compliant Devices */}
        <div className={Styles['complent-device']} onClick={() => handleOnClick('Compliance:true')}>
          <div className="text-base font-normal w-[90px]">Compliant Devices</div>
          <div className="text-5xl font-semibold">{compliancesInfo?.compliance?.value}</div>
        </div>

        {/* Total */}
        <div className={Styles['total-device']}>
          <div className="flex flex-col">
            <div className="text-base font-normal">Total Devices Scanned</div>
            <div className="text-5xl font-semibold mt-1">{compliancesInfo?.totalDevices?.value}</div>
          </div>
        </div>

        {/* Non-compliant Devices */}
        <div className={Styles['non-complent-device']} onClick={() => handleOnClick('Compliance:false')}>
          <div className="text-base font-normal w-[130px]">Non Compliant Devices</div>
          <div className="text-5xl font-semibold">{compliancesInfo?.nonCompliance?.value}</div>
        </div>
      </div>
    </Card>
  );
};

export default DeviceBreakedown;
